import { LocaleVariant } from './Locale'
import { Role } from '../hooks/useRole'

export type MenuItem = {
  href: string
  role: 'guest' | 'user' | 'all'
  icon: string
  label: LocaleVariant
}

export let menuItems: MenuItem[] = [
  {
    href: '/',
    role: 'all',
    icon: 'fa-solid fa-pencil',
    label: {
      en: 'Generate Scene',
      zh_cn: '生成場景',
      zh_hk: '生成場景',
    },
  },
  {
    href: '/tripo3d',
    role: 'all',
    icon: 'fa-solid fa-pencil',
    label: {
      en: 'Generate 3d Object',
      zh_cn: '生成3d物件',
      zh_hk: '生成3d物件',
    },
  },
  {
    href: '/world-builder',
    role: 'all',
    icon: 'fa-solid fa-cube',
    label: {
      en: '3D World Builder',
      zh_cn: '3D世界构建器',
      zh_hk: '3D世界構建器',
    },
  },
  {
    href: '/assets',
    role: 'all',
    icon: 'fa-solid fa-cube',
    label: {
      en: 'Assets',
      zh_cn: '资源',
      zh_hk: '資源',
    },
  },
  // {
  //   href: '/gallery',
  //   role: 'all',
  //   icon: 'fa-solid fa-images',
  //   label: {
  //     en: 'Explore',
  //     zh_cn: '探索',
  //     zh_hk: '探索',
  //   },
  // },
  // {
  //   href: '/gallery?history=true',
  //   role: 'user',
  //   icon: 'fa-solid fa-cube',
  //   label: {
  //     en: 'My Scenes',
  //     zh_cn: '我的场景',
  //     zh_hk: '我的場景',
  //   },
  // },
  {
    href: '/credit',
    role: 'all',
    icon: 'fa-solid fa-crown',
    label: {
      en: 'Credit',
      zh_cn: '会员点数',
      zh_hk: '會員點數',
    },
  },
  {
    href: '/login',
    role: 'guest',
    icon: 'fa-solid fa-user',
    label: {
      en: 'Login',
      zh_cn: '登录',
      zh_hk: '登入',
    },
  },
  {
    href: '/profile',
    role: 'user',
    icon: 'fa-solid fa-user',
    label: {
      en: 'Profile',
      zh_cn: '个人资料',
      zh_hk: '個人資料',
    },
  },
]

export function getMenuItems(props: { role: Role }) {
  return menuItems.filter(
    item => item.role === 'all' || item.role === props.role,
  )
}
